<template>
  <div class="pt-5">
    <span v-if="icon" :class="icon" style="font-size:75px;" />
    <slot></slot>
    <h1 class="pt-4">{{ title }}</h1>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
  }
}
</script>